module.exports = __webpack_public_path__ + "static/candle-steps-27604870375a44e54c366987598691f9.jpg";